import React, { useState } from "react";

const languages = [
    'Is the entity under business rescue or judicial managment?', 'Has the entity ever been placed under provisional liquidation or business rescue', 

  ];
  
const Application = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('COOPERATIVE 1');
    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
    };
const [selected, setSelected] = useState(null); // <-- initially nothing selected

    const [formData, setFormData] = useState({
        firstName: "",
        surname: "",
        email: "",
        postalCode: "",
        idNumber: "",
        mobilePrefix: "+27",
        mobileNumber: "",
        race: "",
        gender: "",
        disability: "",
        picture: null,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    return (
        <div>
            <div className="leading-[1.2] text-center">
                <h2 className="text-[10px] md:text-[24px] font-bold text-[#03897B]">
                LOAN APPLICATION
                </h2>
                <p className="text-[10px] md:text-[18px] font-normal">
                    To be completed by funding applicant
                </p>
            </div>
            <div className="h-2 md:h-5" />

            <div>
                <h2 className="text-[8px] md:text-[24px] font-bold text-[#03897B] -mb-3 ">
                    <span className="text-[#979797]">Section 1 : </span>ENTITY INFORMATION
                </h2>
            </div>
            <div className="h-4 md:h-5" />

            <div className="grid grid-cols-2 md:grid-cols-2 md:gap-6 gap-2">
                {/* Cooperative Name */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold -mb-1 md:mb-1 md:pl-2">Cooperative Name</label>
                    <input type="text" className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] md:px-10 px-2 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium" placeholder="GAUTENG COOPERATIVE" />
                </div>

                {/* Type of organization */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold mb-1 md:pl-2">Type of organization</label>
                    <div className="relative w-full">
                        <div
                            className="bg-[#03897B] w-full h-[20px] md:h-[71px] md:pl-4 pl-2 rounded-[5px] flex items-center justify-between cursor-pointer border-[#152C24] text-white text-[8px] md:text-[24px] font-medium"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            {selectedOption}
                            <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745912768/Expand_down_13_cczugb.png"
                                alt="Expand Icon"
                                className="w-4 h-4 hidden md:flex md:h-[71px] md:w-[80px] bg-[#152C24] md:px-6 md:py-5"
                            />
                            <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745694878/Expand_down_11_jcywal.png"
                                alt="Expand Icon"
                                className="w-4 h-4 md:hidden flex"
                            />
                        </div>

                        {isOpen && (
                            <div className="absolute z-10 mt-1 w-full bg-[#152C24] rounded-[5px] shadow-lg">
                                <div
                                    className="px-4 py-2 text-[#03897B] hover:bg-[#2E453D] cursor-pointer text-[8px] md:text-[32px] font-medium"
                                    onClick={() => handleOptionClick('Service provider')}
                                >
Individual
                                </div>
                                <div
                                    className="px-4 py-2 text-[#03897B] hover:bg-[#2E453D] cursor-pointer text-[8px] md:text-[32px] font-medium"
                                    onClick={() => handleOptionClick('Affiliate')}
                                >
Entrepreneur
                                </div>
                                <div
                                    className="px-4 py-2 text-[#03897B] hover:bg-[#2E453D] cursor-pointer text-[8px] md:text-[32px] font-medium"
                                    onClick={() => handleOptionClick('Partner')}
                                >
Community
                                </div>
                                <div
                                    className="px-4 py-2 text-[#03897B] hover:bg-[#2E453D] cursor-pointer text-[8px] md:text-[32px] font-medium"
                                    onClick={() => handleOptionClick('Partner')}
                                >
Cooperative
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Registration number */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold -mb-1 md:pl-2">Registration number</label>
                    <input type="text" className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium" placeholder="2012/123456/23" />
                </div>

                {/* Members */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold -mb-1 md:pl-2">Members of the Organization</label>
                    <input type="text" className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[24px] placeholder:text-black font-medium" placeholder="2300" />
                </div>

                {/* Mobile */}
                <div>
                    <label className="block text-[8px] md:text-[24px] font-bold mb-1 md:pl-2">WhatsApp / Mobile phone number</label>
                    <div className="flex flex-row items-center">
                        <div className="flex-1 md:mt-0 -mt-1.5">
                            <input
                                type="tel"
                                name="mobileNumber"
                                value={formData.mobileNumber}
                                onChange={handleChange}
                                placeholder="0723456790"
                                className="w-full h-[20px] md:h-[71px] p-1 md:px-10 border-[#D9D9D9] rounded-[5px] text-[8px] md:text-[24px] text-black font-medium placeholder:text-black bg-[#D9D9D9]"
                            />
                        </div>
                    </div>
                </div>
 {/* Address */}
 <div>
    <label className="block text-[8px] md:text-[24px] font-bold -mb-1 md:pl-2">Physical Address</label>
    <input type="email" className="bg-[#D9D9D9] w-full h-[20px] md:h-[71px] px-2 md:px-10 rounded-[5px] border-[#D9D9D9] outline-none text-[8px] md:text-[32px] placeholder:text-black font-medium" placeholder="Ent Road, XXXX" />
  </div>


            </div>
            <div className="grid grid-cols-2 md:gap-x-8 md:gap-2 gap-1  mt-5 md:mt-6">
        {languages.map((lang, i) => {
          const isActive = selected === lang;
          return (
            <button
              key={i}
              onClick={() => setSelected(lang)}
              disabled={lang === '-'}
              className={`
                flex items-center justify-between
                md:w-full md:h-[78px] h-[20px]
                bg-[#E7EBEB]
                border border-[#E7EBEB] rounded-[5px]
                md:pl-4  pl-2
              
              `}
            >
              <span className="font-normal leading-tight text-left text-[4px] md:text-[24px] md:w-[460px] ">{lang}</span>

              <span className="flex items-center justify-center rounded-[5px] md:w-[90px] md:h-[78px] w-5 h-5  bg-[#D9D9D9]">
  <span
    className={`
      md:w-[61px] md:h-[61px] w-3 h-3 rounded-full
      ${isActive 
        ? 'bg-[#03897B] md:border-[9px] border-[3px] border-white'
        : 'bg-transparent md:border-[9px] border-[3px] border-white'}
    `}
  />
</span>

            </button>
          );
        })}
      </div>
      <div className="flex justify-end md:mt-6 mt-4">
        <button
          className="flex items-center md:gap-2 gap-2  hover:bg-[#0f1f1a] text-black hover:text-white  md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition"
        >
          Save
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
            alt="Save Icon"
            className="md:w-11 md:h-11 h-3 w-3"
          />
        </button>
      </div>
        </div>
    )
}

export default Application